const routes = [
  {
    path: "/recommendations",
    name: "recommendations",
    component: () => import("@/views/RecommendationsView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/forms",
    name: "forms",
    component: () => import("@/views/FormsView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/forms/:formId",
    name: "form",
    component: () => import("@/views/FormView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/chat/:chatId",
    name: "chat",
    component: () => import("@/views/ChatView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/exams/:examId",
    name: "exam",
    component: () => import("@/views/ExamView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/roles",
    name: "roles",
    component: () => import("@/views/RolesView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/users",
    name: "users",
    component: () => import("@/views/UsersView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/profiles",
    name: "profiles",
    component: () => import("@/views/ProfilesView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/questionnaires",
    name: "questionnaires",
    component: () => import("@/views/QuestionnairesView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/learning-contents",
    name: "learning-contents",
    component: () => import("@/views/LearningContentsView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/learning-paths",
    name: "learning-paths",
    component: () => import("@/views/LearningPathsView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];

export default routes;
